var React = require('react');

function Failure (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"failureAnimationCircle","cx":"35","cy":"35","r":"24","stroke":"#eb3d26","strokeWidth":"2","strokeLinecap":"round","fill":"transparent","key":0}),React.createElement("polyline",{"className":"failureAnimationCheckLine","stroke":"#eb3d26","strokeWidth":"2","points":"25,25 45,45","fill":"transparent","key":1}),React.createElement("polyline",{"className":"failureAnimationCheckLine","stroke":"#eb3d26","strokeWidth":"2","points":"45,25 25,45","fill":"transparent","key":2})]);
}

Failure.defaultProps = {"id":"failureAnimation","className":"animated","viewBox":"0 0 70 70"};

module.exports = Failure;

Failure.default = Failure;
